import {
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ComparisonValueStore } from '../../../stores/comparison-value/comparison-value.state';
import { ComparisonValue } from '../../../models/geo-data';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'app-comparison-value-select',
  standalone: true,
  imports: [MultiSelectModule, FormsModule],
  templateUrl: './comparison-value-select.component.html',
  styleUrl: './comparison-value-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComparisonValueSelectComponent),
      multi: true,
    },
  ],
})
export class ComparisonValueSelectComponent
  implements ControlValueAccessor, OnInit
{
  readonly comparisonStore = inject(ComparisonValueStore);
  @Input() selection: string[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  comparisonValues: ComparisonValue[] = [];
  touched = false;

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    this.setComparisonValues();
  }

  /**
   * Updates the comparisonValues property by retrieving values from the comparisonStore.
   * If no values are retrieved, it resets the selection property to an empty array
   * and triggers the onSelectionChange method with an empty array.
   *
   * @return {void} This method does not return any value.
   */
  setComparisonValues(): void {
    this.comparisonValues = this.comparisonStore.asArray() || [];
    if (!this.comparisonValues.length) {
      this.selection = [];
      this.onSelectionChange([]);
    }
  }

  /**
   * Called when the selection changes in the UI
   */
  onSelectionChange(value: string[]) {
    this.selection = value;
    this.onChange(value || []); // Notify the FormControl
    this.selectionChange.emit(value); // Emit custom event
  }

  // ControlValueAccessor implementation
  writeValue(value: string[]): void {
    this.selection = value || [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Optional: Handle disabled state
  }
}
